import { render, staticRenderFns } from "./paquetes.vue?vue&type=template&id=724a7549&"
import script from "./paquetes.vue?vue&type=script&lang=ts&"
export * from "./paquetes.vue?vue&type=script&lang=ts&"
import style0 from "./paquetes.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports